import {createObjectByChildrenKeys, debounce, objectDeepMerge} from "../utils"
import Singleton from "./Singleton"
import App from "./App"

const STORAGE_KEY = "locales"

class Internationalization extends Singleton {
  storage = {}
  new_keys = {}
  storage_simple_count = 0

  constructor() {
    super()

    // 1. Find languages keys in i18n attr
    try {
      this.storage = JSON.parse(App.APP_DOM_NODE?.dataset?.i18n)
    } catch (e) {
      console.warn("i18n: Language attribute not found", e)
    }

    // 2. In development add compare if all keys are in i18n attr
    if(localStorage.getItem(STORAGE_KEY) === null)
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.storage))

    let content_to_diff = JSON.parse(localStorage.getItem(STORAGE_KEY))
    const diff = Object.keys(content_to_diff).length - Object.keys(this.storage).length

    if(diff !== 0) {
      console.log("YOU SHOULD UPDATE LOCALES FILE! NEW keys: " + diff)
    }

    // 3. If no key found show default

  }

  findByKeys(keys, data) {

    // Result key found
    if(keys.length === 0)
      return data

    if(data[keys[0]] !== undefined) {
      let original = keys.shift()
      return this.findByKeys(keys, data[original])
    } else {

      //console.error(`JS lang key ${keys} not exist`)
      return undefined

    }
  }

  $t(keys, def = "") {
    // Data are stored in data-i18n
    const dev_mode = (process.env.NODE_ENV === "development")

    if(typeof keys === "string")
      keys = [keys]

    const res = this.findByKeys([...keys], this.storage)

    if(res === undefined) {
      this.storageAddKey(keys, def)
    }

    return (res !== "" && !dev_mode) ? res : def

  }

  storageAddKey(keys, def) {
    this.new_keys = objectDeepMerge(this.new_keys, createObjectByChildrenKeys([...keys], def))

    this.saveToStorage(this.new_keys)
  }

  saveToStorage = debounce((new_keys) => {
    const current_storage = JSON.parse(localStorage.getItem(STORAGE_KEY))

    localStorage.setItem(STORAGE_KEY,
      JSON.stringify(objectDeepMerge(current_storage, new_keys))
    )
    console.log("Add new keys to LOCAL STORAGE")

  }, 300)

  $tc(...args) {
    const storage = JSON.parse(localStorage.getItem(STORAGE_KEY))

    const count = args.pop()
    const plurals = this.findByKeys(args, storage).split("|").map(item => item.trim())

    if(count === 1)
      return plurals[0]
    if(plurals.length === 3 && (4 < count || count === 0))
      return plurals[2]

    return plurals[1]
  }
}

export function $t(keys, def = "") {
  return Internationalization.instance.$t(keys, def)
}

export function $tc(...args) {
  return Internationalization.instance.$tc(...args)
}

export function generateJSONToI18nAttr(type = "lang", json = localStorage.getItem(STORAGE_KEY)) {

  function sortObject(obj) {
    return Object.keys(obj).sort().reduce(function (result, key) {
      result[key] = obj[key]
      return result
    }, {})
  }

  if(typeof json === "string")
    json = JSON.parse(json)

  json = sortObject(json)

  function loop(json) {
    let result = "",
      index = 0,
      length = (typeof json === "object") ? Object.keys(json).length : json.length

    for (let item in json) {
      result += `"${item}": `

      if(Array.isArray(json[item]) || typeof json[item] === "object") {
        result += loop(json[item])
      } else
        if(type === "text")
          result += `"${json[item]}"`
        else
          result += `"{~lang ${item}~}"`

      if(index++ < length - 1)
        result += `,`
    }
    return `{${result}}`
  }

  const result = `${loop(json)}`
  console.log(result)
  return result
}

